<template>
  <div class="box-con-reco">
    <div class="hd z-flex z-flex-between">
      <div class="hd-l">热门赛事推荐</div>
      <el-button class="btn-refresh" type="text" @click="refresh">
       <i class="el-icon-refresh el-icon--left"></i>换一批
      </el-button>
    </div>
    <div class="bd">
      <matchItem :itemData="item" v-for="(item, index) in recoList" :key="index"></matchItem>
    </div>
  </div>
</template>

<script>
import matchItem from '@/components/item/matchItem';
export default {
  components: {
    matchItem,
  },
  name: "recoMatch",
  props: {
    
  },
  data() {
    return {
      recoList:[
        {
          deadline: "2023-01-01",
          id: 128,
          img: "http://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/f23/fb6/f23fb6004e022988050c4bb37d23b3e3.jpg?x-oss-process=image/resize,m_lfit,w_330",
          title: "2021“摄影发现西沙”全国摄影作品展",
        },{
          deadline: "2023-01-01",
          id: 128,
          img: "http://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/f23/fb6/f23fb6004e022988050c4bb37d23b3e3.jpg?x-oss-process=image/resize,m_lfit,w_330",
          title: "2021“摄影发现西沙”全国摄影作品展",
        },
      ],
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //换一批
    refresh(){

    }
  },
};
</script>

<style lang="scss" scoped>
.box-con-reco{
  .bd{
    ::v-deep .match-item{
      height:245px;
      margin:20px 0;
      .img-wrap{
        height:150px;
      }
    }
  }
}
</style>
